module.exports = __webpack_public_path__ + "img/symbol_10.2e87ab60.png";